import { NgModule } from '@angular/core';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { HeaderComponent } from './components/header/header.component';
import { ExperiencesComponent } from './pages/experiences/experiences.component';
import { ControlPanelComponent } from './pages/control-panel/control-panel.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { LoginComponent } from './components/login/login.component';
import { FooterComponent } from './components/footer/footer.component';
import { GalleriaModule } from 'primeng/galleria';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { CalendarModule } from 'primeng/calendar';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { DividerModule } from 'primeng/divider';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { CardModule } from 'primeng/card';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { CarouselModule } from 'primeng/carousel';
import { ImageModule } from 'primeng/image';
import { ScrollTopModule } from 'primeng/scrolltop';
import { SkeletonModule } from 'primeng/skeleton';
import { ToolbarModule } from 'primeng/toolbar';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { HttpClientModule } from '@angular/common/http';
import { ResourceService } from './utils/resource/resource.service';
import { ExperiencesMapComponent } from './components/experiences-map/experiences-map/experiences-map.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SliderModule } from 'primeng/slider';
import { ExperienceModule } from './modules/experience/experience.module';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { TerritoryModule } from './modules/territory/territory-card/territory.module';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TerritoriesComponent } from './pages/territories/territories/territories.component';
import { RegionsComponent } from './pages/regions/regions/regions.component';
import { TranslateModule } from '@ngx-translate/core';




@NgModule({
  declarations: [HomepageComponent, HeaderComponent, ExperiencesComponent, ControlPanelComponent, AboutUsComponent, LoginComponent, FooterComponent, ExperiencesMapComponent, TerritoriesComponent, RegionsComponent],
  exports: [HomepageComponent, HeaderComponent, ExperiencesComponent, ControlPanelComponent, AboutUsComponent, LoginComponent, FooterComponent, ExperiencesMapComponent, RegionsComponent, TranslateModule],
  imports: [
    HttpClientModule,
    CommonModule,
    FormsModule,
    RouterModule,
    InputTextModule,
    ImageModule,
    InputNumberModule,
    GalleriaModule,
    MenubarModule,
    ButtonModule,
    ExperienceModule,
    TerritoryModule,
    CarouselModule,
    CalendarModule,
    ScrollTopModule,
    SkeletonModule,
    ToolbarModule,
    ScrollPanelModule,
    AutoCompleteModule,
    MultiSelectModule,
    OverlayPanelModule,
    SliderModule,
    CheckboxModule,
    DividerModule,
    IconFieldModule,
    InputIconModule,
    CardModule,
    ToggleButtonModule,
    InputGroupModule,
    InputGroupAddonModule,
    FloatLabelModule,
    SplitButtonModule,
    TranslateModule
],
  providers: [
    ResourceService,
    CurrencyPipe
  ]
})
export class AppModule { }
